const { default: axios } = require("axios");

window.makeAjaxRequest = function (url, options) {
  axios
    .post(
      url,
      {},
      {
        headers: {
          "X-PARTIAL-APPEND": !!options.append,
        },
      },
    )
    .then((response) => {
      var data = response.data;

      window.history.replaceState({}, "", url);

      for (var partial in data) {
        let selector = partial;

        if (typeof selector !== "string" || ["#", ".", "@"].indexOf(selector.charAt(0)) === -1) {
          return;
        }

        let mode = "normal";

        if (["@"].indexOf(selector.charAt(0)) !== -1) {
          selector = selector.substring(1);
          mode = "append";
        }

        [].forEach.call(document.querySelectorAll(selector), function (el) {
          if (mode == "append") {
            el.insertAdjacentHTML("beforeEnd", data[partial]);
          } else {
            el.innerHTML = data[partial];
          }
        });
      }

      if (options.scrollTo && document.querySelector(options.scrollTo)) {
        window.scrollTo({
          top: document.querySelector(options.scrollTo).offsetTop,
          behavior: "smooth",
        });
      }
    })
    .finally(() => {
      window.dispatchEvent(
        new CustomEvent("ajax:always", {
          bubbles: true,
          cancelable: true,
        }),
      );
    });
};

document.addEventListener("click", function (e) {
  var el = e.target.dataset.request !== undefined ? e.target : e.target.closest("[data-request]");

  if (!el || !el.href) {
    return;
  }

  e.preventDefault();

  makeAjaxRequest(el.href, {
    append: el.dataset.requestAppend !== undefined,
    scrollTo: el.dataset.scrollTo,
  });
});

window.toggleCountries = function (el) {
  el.classList.toggle("active");

  el.closest(".counties-filter").querySelector(".counties-list").classList.toggle("active");
};

var checkHeight = function () {
  var filter = document.getElementById("countries_filter");

  if (!filter) {
    return;
  }

  var list = filter.querySelector(".counties-list");
  var height = parseInt(getComputedStyle(list).height);
  var lineHeight =
    parseInt(getComputedStyle(list.querySelector(".country")).height) +
    parseInt(getComputedStyle(list.querySelector(".country")).getPropertyValue("margin-top")) +
    parseInt(getComputedStyle(list.querySelector(".country")).getPropertyValue("margin-bottom"));

  if (!lineHeight) {
    return;
  }

  var lines = Math.floor(height / lineHeight);

  if (lines < 2) {
    return;
  }

  filter.querySelector(".show-more").classList.remove("hidden");
};

document.addEventListener("DOMContentLoaded", function () {
  checkHeight();
});

window.addEventListener("ajax:always", function () {
  checkHeight();
});

window.addEventListener("resize", function () {
  checkHeight();
});
